import MainCart from "../components/Cart/MainCart/MainCart";

const Cart = () => {
  return <MainCart></MainCart>;
};

export default Cart;
